<template>
  <div id="batch">
    <div class="batch-wrap">
      业务数据报表
      <div class="filter-wrap">
        <div class="line1">
          <SelectComponent :list="channels" :labelname="'渠道名称'" :placeholder="'请选择一个渠道'" class="filter-item"
                           @change="val=>channelid = val"></SelectComponent>
          <SelectComponent :list="agencynames" :labelname="'代理商名称'" :placeholder="'请选择一个代理商'"
                           class="filter-item" @change="val=>agencyname = val"></SelectComponent>
          <SelectComponent :list="agencyids" :labelname="'代理商ID'" :placeholder="'请选择一个代理商ID'"
                           class="filter-item" @change="val=>agencyid = val"></SelectComponent>
          <SelectComponent :list="corporations" :labelname="'公司名称'" :placeholder="'请选择一个公司'"
                           class="filter-item" :big-data-scroll="true" @change="val=>corporationname = val"></SelectComponent>
        </div>
        <div class="line2">
          搜索：
          <a-input-search placeholder="请输入账户名称、账户ID、APPID或原始ID" style="width: 320px" v-model="other"/>
          <a-button type="primary" style="margin-left: 32px" @click="getList(1)">查询</a-button>
        </div>

      </div>
      <div class="content-wrap">
        <div class="btn-wrap">
          <a-button @click="download" :loading="downloadloading">导出</a-button>
          <a-popconfirm placement="bottomRight" ok-text="确定" cancel-text="取消" @confirm="confirm" @cancel="cancelConfig"
                        :visible="configvisible">
            <i slot="icon"/>
            <template slot="title">
              <div>
                <div style="width: 700px">
                  <a-checkbox-group
                    v-model="config"
                    name="checkboxgroup"
                    :options="options"
                  />
                </div>
              </div>
            </template>
            <a-button style="margin-left: 16px" @click="()=>configvisible=true">自定义列表</a-button>
          </a-popconfirm>
        </div>
        <div class="table-wrap" style="margin-top: 16px">
          <a-table
            :columns="selfcolumns"
            :loading="loading"
            :data-source="tableData"
            :pagination="false"
            :scroll="{ x:tableWidth}"
            @change="tableChange"
          >

          </a-table>
          <Pagination
            :pageSize="pageSize"
            :current="current"
            :total="total"
            @size="size=>getList(1,size)"
            @current="current=>getList(current)"
          ></Pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import moment from 'moment'
import SelectComponent from './selectcomponent'
import { getReportList, getSelectType, downloadExcel } from '../../api'
import Pagination from '../../components/Pagination'
import axios from 'axios'
import store from '../../store/index'
import PopTip from '../../components/popover-tip'

const h = new Vue().$createElement
const options = [
  {label: '渠道名称', value: 'channelname', disabled: true},
  {label: '代理商名称', value: 'agencyname', disabled: true},
  {label: '代理商ID', value: 'agencyid'},
  {label: '账户名称', value: 'accountname', disabled: true},
  {label: '账户ID', value: 'accountid', disabled: true},
  {label: '公司名称', value: 'corporationname'},
  {label: '广告主关联ID', value: 'associationid'},
  {label: '原始微信ID', value: 'wxoriginalid'},
  {label: '行业分类', value: 'firstindustryname'},
  {label: '二级行业分类', value: 'secondaryindustryid'},
  {label: '账户余额', value: 'balance'},
  {label: '现金余额', value: 'cashbalance'},
  {label: '信用余额', value: 'creditrollbalance'},
  {label: '赠送金余额', value: 'giftbalance'},
  {label: '昨日消耗', value: 'cost'},
  {label: '近3天日均消耗', value: 'cost3'},
  {label: '可消耗天数-3', value: 'doc3'},
  {label: '近7天日均消耗', value: 'cost7'},
  {label: '可消耗天数-7', value: 'doc7'},
  {label: '销售团队', value: 'salegroup'},
  {label: '客户付款方式', value: 'cpaytype'}
]
const columns = [
  {
    title: '渠道名称',
    dataIndex: 'channelname',
    width: 150

  },
  {
    title: '代理商名称',
    dataIndex: 'agencyname',
    width: 170
  },
  {
    title: '代理商ID',
    dataIndex: 'agencyid',
    width: 150
  },
  {
    title: '账户名称',
    dataIndex: 'accountname',
    width: 100,
    customRender: text => (<PopTip title={text}></PopTip>)
  },
  {
    title: '账户ID',
    dataIndex: 'accountid',
    width: 150
  },
  {
    title: '公司名称',
    dataIndex: 'corporationname',
    width: 150,
    customRender: text => (<PopTip title={text}></PopTip>)
  },
  {
    title: '广告主关联id',
    dataIndex: 'associationid',
    width: 150
  },
  {
    title: '原始微信ID',
    dataIndex: 'wxoriginalid',
    width: 150
  },
  {
    title: '行业分类',
    dataIndex: 'firstindustryname',
    width: 150
  },
  {
    title: '二级行业分类',
    dataIndex: 'secondaryindustryid',
    width: 150
  },
  {
    title: '账户余额',
    dataIndex: 'balance',
    width: 150,
    align: 'right',
    customRender: val => Number(val).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}),
    sorter: true,
    defaultSortOrder: 'descend',
  },
  {
    title: '现金余额',
    dataIndex: 'cashbalance',
    width: 150,
    align: 'right',
    customRender: val => Number(val).toLocaleString({minimumFractionDigits: 2, maximumFractionDigits: 2}),
    sorter: true
  },
  {
    title: '信用余额',
    dataIndex: 'creditrollbalance',
    width: 150,
    align: 'right',
    customRender: val => Number(val).toLocaleString({minimumFractionDigits: 2, maximumFractionDigits: 2}),
    sorter: true
  },
  {
    title: '赠送金余额',
    dataIndex: 'giftbalance',
    width: 150,
    align: 'right',
    customRender: val => Number(val).toLocaleString({minimumFractionDigits: 2, maximumFractionDigits: 2}),
    sorter: true
  },
  {
    title: '昨日消耗',
    dataIndex: 'cost',
    width: 150,
    align: 'right',
    customRender: val => Number(val).toLocaleString({minimumFractionDigits: 2, maximumFractionDigits: 2}),
    sorter: true
  },
  {
    title: '近3天日均消耗',
    dataIndex: 'cost3',
    width: 200,
    align: 'right',
    customRender: val => Number(val).toLocaleString({minimumFractionDigits: 2, maximumFractionDigits: 2}),
    sorter: true
  },
  {
    title: '可消耗天数-3',
    dataIndex: 'doc3',
    width: 200,
    align: 'right',
    customRender: val => Number(val).toLocaleString({minimumFractionDigits: 2, maximumFractionDigits: 2}),
    sorter: true
  },
  {
    title: '近7天日均消耗',
    dataIndex: 'cost7',
    width: 200,
    align: 'right',
    customRender: val => Number(val).toLocaleString({minimumFractionDigits: 2, maximumFractionDigits: 2}),
    sorter: true
  },
  {
    title: '可消耗天数-7',
    dataIndex: 'doc7',
    width: 200,
    align: 'right',
    customRender: val => Number(val).toLocaleString({minimumFractionDigits: 2, maximumFractionDigits: 2}),
    sorter: true
  },
  {
    title: '销售团队',
    dataIndex: 'salegroup',
    width: 200
  },
  {
    title: '客户付款方式',
    dataIndex: 'cpaytype',
    width: 200
  }
]

export default {
  name: 'batch',
  components: {
    SelectComponent,
    Pagination,
    PopTip
  },
  data() {
    return {
      // list: [],
      downloadloading: false,
      other: undefined,
      channelid: undefined,
      agencyname: undefined,
      agencyid: undefined,
      corporationname: undefined,
      sorts: [
        {field: 'balance', type: 'DESC'}
      ],
      channels: [],
      agencynames: [],
      agencyids: [],
      corporations: [],
      configvisible: false,
      tableData: [],
      columns,
      moment,
      pageSize: 10,
      total: 0,
      current: 1,
      loading: false,
      // plainOptions,
      options,
      config: ['channelname', 'agencyname', 'accountid', 'accountname', 'corporationname', 'balance', 'cashbalance', 'cost', 'cost3', 'doc3', 'cost7', 'doc7', 'salegroup', 'cpaytype'],
      configcache: ['channelname', 'agencyname', 'accountid', 'accountname', 'corporationname', 'balance', 'cashbalance', 'cost', 'cost3', 'doc3', 'cost7', 'doc7', 'salegroup', 'cpaytype']
    }
  },
  created() {
    // for(var i=0;i<1000;i++){
    //   this.list.push({
    //     val: i,
    //     name: i+''
    //   })
    // }
    this.initFilter()
    this.getList()
  },
  computed: {
    fts() {
      let obj = [];
      ['other', 'channelid', 'agencyname', 'agencyid', 'corporationname'].forEach(item => {
        if (this[item]) {
          obj.push({
            field: item,
            operator: 'EQUALS',
            values: [
              this[item]
            ]
          })
        }
      })
      return obj
    },
    selfcolumns() {
      return columns.filter(item => {
        return this.configcache.includes(item.dataIndex)
      })
    },
    tableWidth() {
      return this.selfcolumns.reduce((prev, curr) => {
        return prev + (curr.width)
      }, 0) + 50
    }
  },
  methods: {
    tableChange(pagination, filters, sorter) {
      if (JSON.stringify(pagination) === '{}' && JSON.stringify(filters) === '{}') {
        if (JSON.stringify(sorter) === '{}') {
          this.sorts = []
        } else if (sorter.order === 'descend') {
          this.sorts = [{
            field: sorter.columnKey,
            type: 'DESC'
          }]
        } else {
          this.sorts = [{
            field: sorter.columnKey,
            type: 'ASC'
          }]
        }
        this.getList(1)
      }
    },
    getDownloadFile(data) {
      this.downloadloading = true
      axios({
        timeout: 20 * 60 * 1000,
        method: 'post',
        url: `${process.env.VUE_APP_BASE_API_BIZ}/api/biz/file/downloadSummary`,
        responseType: 'blob',
        headers: {'token': store.state.auth.token},
        data: data
      }).then(res => {
        // 将二进制数据流转成URL对象
        const url = window.URL.createObjectURL(
          res.data
        )
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${data.filename}.xls`)
        document.body.appendChild(link)
        link.click()
      }).finally(()=>{
        this.downloadloading = false
      })
    },
    download() {
      let map = this.options.reduce((pre, cur) => {
        pre[cur.value] = cur.label
        return pre
      }, {})
      let sortmap = options.map(item=>item.value).reduce((pre,cur,index)=>{
        pre[cur] = index
        return pre
      },{})
      // console.log(sortmap)
      this.getDownloadFile({
        filename: `业务数据报表${moment().format('YYYYMMDD')}`,
        fts: this.fts,
        sorts: [],
        fields: this.configcache.sort((a,b)=>{
          return sortmap[a] - sortmap[b]
        }).map(item => {
          return {
            name: item,
            alias: map[item]
          }
        })
      })
    },
    initFilter() {
      getSelectType({
        type: 'CHANNEL'
      }).then(res => {
        this.channels = res.map(item => {
          return {
            name: item.channelname,
            val: item.channelid + ''
          }
        })
      })
      getSelectType({
        type: 'AGENCYNAME'
      }).then(res => {
        this.agencynames = res.map(item => {
          return {
            name: item.agencyname,
            val: item.agencyname
          }
        })
      })
      getSelectType({
        type: 'AGENCYID'
      }).then(res => {
        this.agencyids = res.map(item => {
          return {
            name: item.agencyid,
            val: item.agencyid + ''
          }
        })
      })
      getSelectType({
        type: 'CORPORATION'
      }).then(res => {
        this.corporations = res.map((item, index) => {
          return {
            name: item.corporationname,
            val: item.corporationname
          }
        })
      })
    },
    cancelConfig() {
      this.config = this.configcache
      this.configvisible = false
    },
    confirm() {
      this.configcache = this.config
      this.getList(this.current)
      this.configvisible = false
    },
    getList(current = 1, pageSize = this.pageSize) {
      this.loading = true
      getReportList({
        fts: this.fts,
        sorts: this.sorts,
        fields: this.configcache,
        page: current,
        size: pageSize
      }).then(res => {
        console.log(res)
        this.pageSize = pageSize
        this.current = current
        this.total = res.total
        this.tableData = res.list.map((item, index) => {
          item.key = index
          item.agencyname = item.agencyname || '--'
          item.accountname = item.accountname || '--'
          item.associationid = item.associationid || '--'
          item.wxoriginalid = item.wxoriginalid || '--'
          item.firstindustryname = item.firstindustryname || '--'
          item.secondaryindustryid = item.secondaryindustryid || '--'
          item.cpaytype = item.cpaytype || '--'
          item.salegroup = item.salegroup || '--'
          return item
        })
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang='less'>
  @import '../../common/styles/varibles.less';
  @import '../../common/styles/mixins.less';

  #batch {
    .batch-wrap {
      /*position: absolute;*/
      /*top: 64px;*/
      /*bottom: 0;*/
      /*right: 0;*/
      /*left: 0;*/
      /*overflow: scroll;*/
      background-color: @f567;
      padding: 8px 18px;

      .filter-wrap {
        margin-top: 10px;
        width: 100%;
        padding: 24px;
        /*height: 56px;*/
        background-color: @w;

        .line1 {
          display: flex;

          .filter-item {
            flex: 1;

          }
        }
      ;

        .line2 {
          display: flex;
          align-items: center;
          margin-top: 20px;
          width: 100%;
        }
      }

      .content-wrap {
        padding: 24px;
        margin-top: 20px;
        background-color: @w;

        .btn-wrap {
          display: flex;
          justify-content: flex-end;
        }

        .table-wrap {
          margin-top: 16px;
        }
      }
    }
  }
</style>
